module.exports = __webpack_public_path__ + "static/media/celso_sign.86c0fea9.png";